module.exports = __webpack_public_path__ + "static/media/avatar_30.b666910a.svg";